import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { VerificationLinkPoc } from "../../actions/VerificationLinkPoc";
import { unsupportedMedia, uploadFileAction } from "../../actions/Uploadaction";
import { liveFeedback } from "../../actions/liveFeddback";
import { updateSession } from "../../helpers/updateSessionHandler";
import Upload from "../../Components/view/Upload";
import PleaseWait from "../../Components/templates/waiting.template";
import UploadStatus from "../../Components/uploadStatus";
import ThankYouModal from "../../Components/templates/thankyou.template";
import UrlNotFound from "../../Components/newTemplates/urlNotFound";
import { ProgressWidget } from "../../Components/newTemplates/ProgressWidget";
import UnsupportedMedia from "../../Components/templates/unsupported_file.template";
import {
  BUTTONID_IS_NULL,
  FILE_ALREADY_EXISTS,
  LIMIT_EXCEED,
  ONESHOTUPLOAD_FAILURE,
  ONESHOTUPLOAD_START,
  ONESHOTUPLOAD_SUCCESS,
  URL_NOT_FOUND,
  SOMETHING_WENT_WRONG,
  IS_VERIFYING,
  SHOW_PROGRESS_LOADER,
  IMAGE_UPLOAD,
  IMAGE_UNPROCESSABLE,
  IMAGE_NOT_ALLOWED,
  PASSWORD_PROTECTED
} from "../../actions/actionTypes";
import { sendLogs } from "../../helpers/sendLogs";
import axios from "axios";
import { env as environment } from "../../environments";
import {
  PdfToBase64,
  b64toBlob,
  blobToFile,
} from "../../helpers/pdfFileChangerHandler";
//import DocumentNotOriginal from "../../Components/newTemplates/DocumentNotOriginal";
import ButtonIdNotFound from "../../Components/newTemplates/ButtonIdNotFound";
import SomethingWentWrong from "../../Components/newTemplates/somethingWentWrong";
import PasswordProtected from "../../Components/newTemplates/passwordProtected";
import CorruptFile from "../../Components/newTemplates/corruptFile";
import LimitExceed from "../../Components/newTemplates/limitExceed";
import LiveFeedbackInvalidPopup from "../../Components/view/LiveFeedbackInvalidPopup";
import { convertPngToJpeg } from "../../helpers";
import ImageToPdfFailed from "../../Components/newTemplates/ImageToPdfFailed";
import {
  s3fileHandler,
  appendS3FilenameArrayPartForSession,
} from "../../actions/uploads3_Action";
import { checkPasswordProtectedPdf } from "../../helpers/checkPasswordProtectedPdf";
import { logFormDataPayload } from "../../helpers/logFormDataPayload";

export default function Wrapper() {
  const [params, setParams] = useState({});
  const [allFiles, setAllFiles] = useState([]);
  const [allProcessedFiles, setAllProcessedFiles] = useState([]);
  const progressRef = useRef();

  // Get already saved liveFeedback responses from store.
  const allLiveFeedbackResponses = useSelector(
    (state) => state.livefeedback?.allLivefeedbackResponses
  );

  // Check if document is invalid
  const livefeedbackInvalidDoc = useSelector(
    (state) => state.livefeedback?.livefeedbackInvalidDoc
  );

  const somethingWentWrong = useSelector(
    (state) => state.upload?.somethingWentWrong
  );

  const lastLinkClickedData = useSelector(
    (state) => state.lastLinkClicked?.dataSuccess
  );

  const isVerifying = useSelector((state) => state?.upload?.isVerifying);
  const urlNotFound = useSelector((state) => state?.oneShotUpload?.error);

  const processingLivefeedback = useSelector(
    (state) => state?.livefeedback?.processingLivefeedback
  );

  const processingOneShotUpload = useSelector(
    (state) => state?.oneShotUpload?.oneShotStart
  );

  const oneShotUploadSuccessResponse = useSelector(
    (state) => state?.oneShotUpload?.oneShotSuccess
  );

  const passwordProtected = useSelector(
    (state) => state?.upload?.passwordProtected
  );

  const corruptFile = useSelector((state) => state?.upload?.corruptFile);

  const limitExceed = useSelector((state) => state?.upload?.limitExceed);

  const imageNotAllowed = useSelector((state) => state?.upload?.imageNotAllowed);

  const documentIsVerified = useSelector(
    (state) => state?.upload?.documentIsVerified
  );

  const documentIsWrong = useSelector(
    (state) => state?.upload?.documentIsWrong
  );

  const isUnsupportedMedia = useSelector(
    (state) => state?.upload?.unsupportedMedia
  );

  const fileAlreadyExists = useSelector(
    (state) => state?.upload?.fileAlreadyExists
  );

  const documentIsNotOriginal = useSelector(
    (state) => state?.upload?.documentIsNotOriginal
  );

  const buttonIdIsNull = useSelector((state) => state?.upload?.buttonIdIsNull);

  const errorInVerificationPoc = useSelector(
    (state) => state?.verificationLinkPOC?.error
  );

  const subcategorySelected = useSelector(
    (state) => state.livefeedback?.subcategorySelected
  );

  const documentSelected = useSelector(
    (state) => state.livefeedback?.documentSelected
  );

  const showProgressLoader = useSelector(
    (state) => state.upload?.showProgressLoader
  );

  const progressLivefeedbackLoader = useSelector(
    (state) => state.livefeedback?.progressLivefeedbackLoader
  );

  const imageUnprocessable = useSelector(
    (state) => state.livefeedback?.imageUnprocessable
  );

  console.log(imageUnprocessable, 'imageUnprocessable checkk')

  // const liveFeedbackData = useSelector(
  //   (state) => state.livefeedback?.livefeedbackData
  // );

  const dispatch = useDispatch();
  useEffect(() => {
    console.log("document.documentElement.style", document.documentElement.style);
    document.documentElement.style.setProperty(
      '--dynamic-color', 
      lastLinkClickedData?.button?.setcolor || '#000'
    );
  
  }, [lastLinkClickedData?.button?.setcolor]);

  useEffect(() => {
    if (progressRef.current) {
      progressRef.current.updateProgressAndMessage(progressLivefeedbackLoader);
    }
  }, [progressLivefeedbackLoader]);
  useEffect(() => {
    if (lastLinkClickedData?.button?.setcolor) {
      document.documentElement.style.setProperty('--dynamic-color', lastLinkClickedData.button.setcolor);
    }
  }, [lastLinkClickedData]);

  const getPdfFileName = (fileName) => {
    const fileNameWithoutExtension = fileName.split('.').slice(0, -1).join('.');
    const extension = fileName.split('.').pop();
    return `${fileNameWithoutExtension}.pdf`;
  }
  // Shared processing for both file-select and drag-drop. `filesToAdd` is the
  // list appended to allFiles (multiple for select, single for drop).
  const processSelectedFile = async (event, file, filesToAdd) => {
      const fileNameNew = getPdfFileName(file.name)

      const fileNameObj = {
        data: {
          originalFileName: fileNameNew,
        },
        sessionid: lastLinkClickedData.sessionid,
      }

     dispatch(updateSession({...fileNameObj}))

      var notSupportedDocument = {
        data: {
          indicator: {
            progress_no: "6",
            progress_name: "Uploaded document not supported",
            Detection: "upload",
          },
        },
        sessionid: lastLinkClickedData.sessionid,
      };
      if (file &&
        ((file.type === "application/pdf") ||
         (lastLinkClickedData?.button?.imageUpload !== false &&
          lastLinkClickedData?.button?.imageUpload !== "false" &&
          (file.type === "image/jpeg" ||
          file.type === "image/png" ||
          file.type === "image/jpg" ||
          file.type === "image/heic" ||
          (file.name.toLowerCase().endsWith('.heic')))))) {
        const fileSizeInBytes = file.size; // Get file size in bytes
        const fileSizeInKB = fileSizeInBytes / 1024; // Convert to KB
        const fileSizeInMB = fileSizeInKB / 1024; // Convert to MB

        let imageToPdfConverted = false;

        if (file.type !== "application/pdf") {
          dispatch({ type: IMAGE_UPLOAD, payload: true });
          if (fileSizeInMB > 5) {
            return dispatch({ type: LIMIT_EXCEED, payload: true });
          }
          s3fileHandler(file,lastLinkClickedData.sessionid,"image");
        } else {
          dispatch({ type: IMAGE_UPLOAD, payload: false });
          if (fileSizeInMB > 50) {
            return dispatch({ type: LIMIT_EXCEED, payload: true });
          }
        }

        if (file.name.toLowerCase().endsWith('.heic') && !file.type) {
          // Create a new File object with the correct MIME type
          const modifiedFile = new File([file], file.name, {
            type: 'image/heic',
            lastModified: file.lastModified,
          });
          file = modifiedFile;
        }
        // if file already exists already, show already exists popup and for the same dispatch the below action.

        if (allFiles.find((item) => item.name === file.name)) {
          return dispatch({ type: FILE_ALREADY_EXISTS, payload: true });
        }

        // Check if PDF is password-protected before processing
        if (file.type === "application/pdf") {
          // Show "Please wait" modal while checking
          dispatch({ type: IS_VERIFYING, payload: true });

          const isPasswordProtected = await checkPasswordProtectedPdf(file);

          if (isPasswordProtected) {
            // Keep showing "Please wait" for a brief moment so user sees it
            await new Promise(resolve => setTimeout(resolve, 1500)); // Show "Please wait" for 1.5 seconds

            // Stop showing "Please wait" and show password protection message
            dispatch({ type: IS_VERIFYING, payload: false });
            dispatch({ type: PASSWORD_PROTECTED, payload: true });
            event.target.value = null;
            return;
          }

          // Not password-protected, continue with normal flow
          dispatch({ type: IS_VERIFYING, payload: false });
        }

        // Handle JPEG, JPG, HEIC file formats
        const imageMimeTypes = ["image/jpeg", "image/jpg", "image/heic", "image/png"];
        if (imageMimeTypes.includes(file?.type)) {

          // dispatch({ type: IS_VERIFYING, payload: true });
          dispatch({ type: SHOW_PROGRESS_LOADER, payload: true });

          const formData = new FormData();

          if (file?.type === "image/png") {
            // Convert PNG file to JPEG format
            const jpegBlob = await convertPngToJpeg(file);
            // Get the converted JPEG data as a blob
            const convertedJPEGData = await new Response(jpegBlob).blob();

            const imageBlob = new Blob([convertedJPEGData], { type: 'image/jpeg' });
            formData.append('file', imageBlob, {
              filename: file.name, // Use the original file name
              contentType: "image/jpg",
            });
          } else {
            // Append the file with proper metadata
            formData.append("file", file, {
              filename: file.name, // Use the original file name
              contentType: file.type,
            });
          }
          formData.append("sessionid", lastLinkClickedData.sessionid);
          const imageToPdfApiUrl = environment.imageToPdfApiUrl;

          const response = await fetch(imageToPdfApiUrl, {
            method: 'POST',
            headers: {
              'Origin': environment.origin
            },
            body: formData
          });

          if (!response.ok) {
            console.log(response, 'response checkk')
            throw {
              status: response.status,
              message: `HTTP error! Status: ${response.status}`
            };
          }

          imageToPdfConverted = true;
          let blob = await response.arrayBuffer().then(buffer => new Blob([buffer], { type: 'application/pdf' }));
          file = blob;
        }
        dispatch(
          uploadFileAction(
            file,
            params,
            lastLinkClickedData.category,
            lastLinkClickedData.sessionid
          )
        );
        setAllFiles([...allFiles, ...filesToAdd]);
        setAllProcessedFiles([...allProcessedFiles, file]);
        dispatch(
          liveFeedback(
            file,
            lastLinkClickedData.category,
            lastLinkClickedData.sessionid,
            fileSizeInMB > 3 ? true : false,
            imageToPdfConverted,
            subcategorySelected,
            documentSelected,
          )
        );


      } else if ( (lastLinkClickedData?.button?.imageUpload === false ||
        lastLinkClickedData?.button?.imageUpload === "false") &&
        (file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/heic" ||
        (file.name.toLowerCase().endsWith('.heic')))){
        dispatch({ type: IMAGE_NOT_ALLOWED, payload: true });
      }else {
        dispatch(unsupportedMedia(true));
        if (params.buttonid) {
          dispatch(
            updateSession(notSupportedDocument, lastLinkClickedData.sessionid)
          );
        }
      }
      event.target.value = null;
  };

  // Function to upload file from system.
  const handleFileSelect = async (event) => {
    try {
      event.preventDefault();
      let file = event.target.files[0] || event.dataTransfer.files[0];
      await processSelectedFile(event, file, [...event.target.files]);
    }
    catch (error) {
      console.log(error, 'error checkk')
      if(error.status == 422) {
        dispatch({ type: IMAGE_UNPROCESSABLE, payload:  true })
        dispatch({ type: SHOW_PROGRESS_LOADER, payload: false });
      } else {
        dispatch({ type: SOMETHING_WENT_WRONG, payload: true })
      }
    };
  }
  // Function to handle browse click event.
  const handleBrowseClick = () => {
    // Trigger click event on file input
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  const fileInputRef = useRef(null);

  // Function to drag & drop file from system.
  const handleDragOver = (event) => {
    event.preventDefault();
  };

  // Function to drag & drop file from system.
  const handleDrop = async (event) => {
    try {
      event.preventDefault();
      let file = event.dataTransfer.files[0];
      let fileDropped = event.dataTransfer.files[0];
      await processSelectedFile(event, file, [fileDropped]);
    }
    catch (error) {
      console.log(error, 'error checkk')
      if(error.status == 422) {
        dispatch({ type: IMAGE_UNPROCESSABLE, payload:  true })
        dispatch({ type: SHOW_PROGRESS_LOADER, payload: false });
      } else {
        dispatch({ type: SOMETHING_WENT_WRONG, payload: true })
      }
    };
  };

  useEffect(() => {
    const newParams = {};
    if (environment["env"] === "CDN") {
      newParams["buttonid"] = environment["buttonId"];
      newParams["trackid"] = environment["trackId"];
      
      // DIRO-5577: Read trackid from URL parameters if present
      console.log('DIRO-5577 DEBUG: window.location.search =', window.location.search);
      console.log('DIRO-5577 DEBUG: window.location.href =', window.location.href);
      
      // Try URLSearchParams first
      let urlTrackId = null;
      if (window.location.search) {
        const urlParams = new URLSearchParams(window.location.search);
        urlTrackId = urlParams.get('trackid');
        console.log('DIRO-5577 DEBUG: trackid from URLSearchParams =', urlTrackId);
      }
      
      // Fallback: Parse from href directly (for file:// protocol)
      if (!urlTrackId && window.location.href.includes('?')) {
        const queryString = window.location.href.split('?')[1];
        console.log('DIRO-5577 DEBUG: Parsed query string from href =', queryString);
        const params = new URLSearchParams(queryString);
        urlTrackId = params.get('trackid');
        console.log('DIRO-5577 DEBUG: trackid from href parsing =', urlTrackId);
      }
      
      // Process widget attributes - ONLY set if they have non-empty values
      const widgetElement = document?.getElementById('reactWidget');
      if (widgetElement) {
        const attributes = widgetElement.attributes;
        console.log('DIRO-5577 DEBUG: Processing widget attributes...');
        for (let i = 0; i < attributes.length; i++) {
          if(attributes[i].name.includes("data-")){
            const attrKey = attributes[i].name.split("-")[1];
            const attrValue = attributes[i].value;
            console.log(`DIRO-5577 DEBUG: Widget attribute [${attrKey}] = "${attrValue}" (has value: ${!!attrValue})`);
            
            // DIRO-5577: Only set attribute if it has a non-empty value
            // This prevents empty widget attributes from overriding URL parameters
            if (attrValue) {
              newParams[attrKey] = attrValue;
              console.log(`DIRO-5577 DEBUG: Set ${attrKey} from widget attribute`);
            } else {
              console.log(`DIRO-5577 DEBUG: Skipped empty widget attribute [${attrKey}]`);
            }
          }
        }
      }
      console.log('DIRO-5577 DEBUG: Params after widget attributes:', newParams);
      
      // DIRO-5577: URL trackid takes PRIORITY over widget attribute
      // This ensures URL parameter always wins when present
      if (urlTrackId) {
        newParams["trackid"] = urlTrackId;
        console.log('DIRO-5577 DEBUG: URL trackid overrides widget attribute. Final trackid:', urlTrackId);
      }
      
      console.log('DIRO-5577 DEBUG: Final params in CDN mode:', newParams);
      setParams(newParams);
      document.documentElement.style.setProperty('--env-cdn-app-header', 'auto');
    } else {
      const queryParams = new URLSearchParams(window.location.search);
      for (const [key, value] of queryParams) {
        newParams[key] = value;
      }
      if (Object.keys(newParams).length > 0) {
        setParams(newParams);
      }
    }
  }, []);

  useEffect(() => {
    console.log('DIRO-5577 DEBUG: Calling VerificationLinkPoc with params:', params);
    if (params && params.hasOwnProperty("buttonid") && params.buttonid) {
      dispatch(VerificationLinkPoc(params));
    } else if (params.hasOwnProperty("buttonid") && !params.buttonid) {
      dispatch({ type: BUTTONID_IS_NULL });
    }
  }, [params]);

  const uploadDoneSession = {
    sessionid: lastLinkClickedData?.sessionid,
    data: {
      indicator: {
        progress_no: "8",
        progress_name: "Done, now in Review ",
        Detection: "upload",
      },
    },
  };

  const uploadFailedSession = {
    sessionid: lastLinkClickedData?.sessionid,
    data: {
      indicator: {
        progress_no: "9",
        progress_name: "Upload error",
        Detection: "upload",
      },
    },
  };

  const oneShotUploadAction = async () => {
    const oneShotPayload = {
      mxid: lastLinkClickedData.mxid,
      sessionid: lastLinkClickedData.sessionid,
      doc_id: lastLinkClickedData.sessionid,
      mcc: lastLinkClickedData.doc.mcc,
      mobile: lastLinkClickedData.doc.mobile,
      category: lastLinkClickedData.data.coverage.category,
      url: "https://sample.diro.me",
      cvd: true,
      hashalgorithm: "md5",
      lang: "en",
      shareonlyjson: lastLinkClickedData.button.shareonlyjson
        ? lastLinkClickedData.button.shareonlyjson
        : false,
    };

    const formData = new FormData();
    console.log(allFiles.length, allProcessedFiles.length)

    if (allFiles.length === allProcessedFiles.length) {
      for (var i = 0; i < allFiles.length; i++) {
        let datetime = new Date().getTime().toString();
        var mhtmlFileName = lastLinkClickedData.sessionid + "-" + datetime + ".pdf";

        var mhtmlb64 = await PdfToBase64(allProcessedFiles[i]);

        var blob = b64toBlob(mhtmlb64, "");
        var file = blobToFile(blob, mhtmlFileName);

        formData.append("downloadedfiles", file, mhtmlFileName);
      }
    } else {
      dispatch({ type: SOMETHING_WENT_WRONG, payload: true });
    }

    formData.append(
      "data",
      new Blob([JSON.stringify(oneShotPayload)], {
        type: "application/json",
      })
    );

    const liveFeedbackData = {};

    for (let i = 0; i < allLiveFeedbackResponses.length; i++) {
      // console.log(
      //   "live feedback console",
      //   (liveFeedbackData[allFiles[i]?.name] = allLiveFeedbackResponses[i])
      // );
      liveFeedbackData[allFiles[i]?.name] = allLiveFeedbackResponses[i];
    }

    formData.append("liveFeedBackData", JSON.stringify(liveFeedbackData));

    if (allFiles.length === allProcessedFiles.length && allFiles.length > 0) {
      appendS3FilenameArrayPartForSession(
        formData,
        lastLinkClickedData.sessionid,
        allFiles.length
      );
    }

    try {
      dispatch({ type: ONESHOTUPLOAD_START });
      await logFormDataPayload(formData, "oneshotupload");

      const response = await axios.post(environment.oneshotupload, formData);
      console.log(response.data, 'here is response data')
      // const response = { error: true, message: "url not found" };
      if (response.data.message === "URL not found") {
        dispatch({ type: URL_NOT_FOUND, payload: response });
        sendLogs(
          "OneShotUpload",
          "OneShotUpload failed due to url not found.",
          "uploading_done.template.js",
          lastLinkClickedData.sessionid,
          "5"
        );
      }
      else {
        var engagementCallbackpayload = {
          sessionid: lastLinkClickedData.sessionid,
        };
      

        dispatch({ type: ONESHOTUPLOAD_SUCCESS, payload: response.data });
        sendLogs(
          "OneShotUpload",
          "OneShotUpload is successfully Done!",
          "uploading_done.template.js",
          lastLinkClickedData.sessionid,
          "5"
        );
        await dispatch(updateSession(uploadDoneSession, lastLinkClickedData.sessionid));
        const engagementCallbackResponse = await axios.post(
          environment.engagementCallback,
          engagementCallbackpayload
        );
      }


    } catch (error) {
      dispatch({
        type: ONESHOTUPLOAD_FAILURE,
        payload: error?.response?.data,
      });
      dispatch({ type: SOMETHING_WENT_WRONG, payload: true });

      dispatch(updateSession(uploadFailedSession, lastLinkClickedData.sessionid));

      sendLogs(
        "OneShotUpload",
        `Error while OneShotUpload!:${error?.response?.data} `,
        "uploading_done.template.js",
        lastLinkClickedData.sessionid,
        "5"
      );
    }
  };

  useEffect(() => {
    if(environment.isWidget){

    const widgetElement = document?.getElementById('reactWidget');

// Get the wrapper attribute value
const wrapperString = widgetElement?.getAttribute('wrapper');

// Parse the JSON string to get an object
const wrapperObject = JSON.parse(wrapperString);

// Access height and width
const height = wrapperObject?.height || "380px"; // "380px"
const width = wrapperObject?.width || "400px";   // "500px"
const fontSizeTitle = wrapperObject?.fontSizeTitle || "16px";
const fontWeightTitle = wrapperObject?.fontWeightTitle || "600";
const fontSizeContent = wrapperObject?.fontSizeContent || "16px";
const fontWeightContent = wrapperObject?.fontWeightContent || "400";
const fontSizeInfo = wrapperObject?.fontSizeInfo || "16px";
const fontWeightInfo = wrapperObject?.fontWeightInfo || "400";
const fontFamily = wrapperObject?.fontFamily;
const buttonHeight = wrapperObject?.buttonHeight;
console.log("Height:", height);
console.log("Width:", width);
console.log("Button Height:", buttonHeight);

    
    if (height) {
      document.documentElement.style.setProperty('--popup-height', height);
    }
    if (width) {
      document.documentElement.style.setProperty('--popup-width', width);
    }
    if(fontSizeTitle){
      document.documentElement.style.setProperty(
        '--dynamic-font-size-title', 
        fontSizeTitle
      );
    }
    if(fontSizeContent){
      document.documentElement.style.setProperty(
        '--dynamic-font-size-content', 
        fontSizeContent
      );
    }
    if(fontSizeInfo){
      document.documentElement.style.setProperty(
        '--dynamic-font-size-info', 
        fontSizeInfo
      );
    }
    if(fontWeightTitle){
      document.documentElement.style.setProperty(
        '--dynamic-font-weight-title', 
        fontWeightTitle
      );
    }
    if(fontWeightContent){
      document.documentElement.style.setProperty(
        '--dynamic-font-weight-content', 
        fontWeightContent
      );
    }
    if(fontWeightInfo){
      document.documentElement.style.setProperty(
        '--dynamic-font-weight-info', 
        fontWeightInfo
      );
      if(buttonHeight){
        document.documentElement.style.setProperty(
          '--dynamic-height-button', 
          buttonHeight
        );
      }
    }
    
    if(fontFamily){
      document.documentElement.style.setProperty(
        '--dynamic-font-family', 
        fontFamily
      );
    }
  }
  }, []);

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        position: environment["env"] === "CDN" ? "relative" : "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: environment["env"] === "CDN" ? "#ffffff" : "#e5e5e5", // Set background color to white
        textAlign: environment["env"] === "CDN" ? "center" : "auto",
        // zIndex: 9999,
      }}
    >
      <div className="starting-info-showing-card d-flex flex-column justify-content-center align-items-center">
        <div className="card" style={{ margin: "10px" }}>
          <>
            {(isVerifying ||
              // processingLivefeedback ||
              processingOneShotUpload ||
              !lastLinkClickedData) &&
              !isUnsupportedMedia &&
              !passwordProtected &&
              !somethingWentWrong &&
              !corruptFile &&
              !showProgressLoader &&
              !limitExceed && 
              !(showProgressLoader || processingLivefeedback) &&
              !(buttonIdIsNull || errorInVerificationPoc) && <PleaseWait  modalColor={lastLinkClickedData?.button?.setcolor}/>}
            {/* {(showProgressLoader || processingLivefeedback) && !limitExceed && !somethingWentWrong && <ProgressWidget ref={progressRef} color={lastLinkClickedData?.button?.setcolor}/>} */}

            {(showProgressLoader || processingLivefeedback) && !limitExceed && !somethingWentWrong && !passwordProtected && <PleaseWait  modalColor={lastLinkClickedData?.button?.setcolor}/>}

            {(buttonIdIsNull || errorInVerificationPoc) && !passwordProtected && (
              <ButtonIdNotFound
                errorInVerificationPoc={errorInVerificationPoc}
              />
            )}
            {!buttonIdIsNull &&
              !errorInVerificationPoc &&
              !livefeedbackInvalidDoc &&
              !isVerifying &&
              !showProgressLoader &&
              !(documentIsVerified || documentIsNotOriginal) &&
              !documentIsWrong &&
              !isUnsupportedMedia &&
              !somethingWentWrong &&
              lastLinkClickedData &&
              !corruptFile &&
              !processingLivefeedback &&
              !(imageUnprocessable==true) && 
              !limitExceed &&
              !passwordProtected && (

                <Upload
                  handleBrowseClick={handleBrowseClick}
                  handleDragOver={handleDragOver}
                  handleDrop={handleDrop}
                  handleFileSelect={handleFileSelect}
                  fileInputRef={fileInputRef}
                />
              )}

            {!isVerifying &&
              (documentIsVerified || documentIsNotOriginal) &&
              !isUnsupportedMedia &&
              !fileAlreadyExists &&
              !processingLivefeedback &&
              !processingOneShotUpload &&
              !livefeedbackInvalidDoc &&
              !isUnsupportedMedia &&
              !livefeedbackInvalidDoc &&
              oneShotUploadSuccessResponse?.error !== false &&
              !somethingWentWrong &&
              !passwordProtected &&
              !corruptFile &&
              !limitExceed &&
              !imageUnprocessable &&
              urlNotFound?.data?.message !== "URL not found" &&
                (
                <UploadStatus
                  handleBrowseClick={handleBrowseClick}
                  handleDragOver={handleDragOver}
                  handleDrop={handleDrop}
                  handleFileSelect={handleFileSelect}
                  fileInputRef={fileInputRef}
                  oneShotUploadAction={oneShotUploadAction}
                  allFiles={allFiles}
                  setAllFiles={setAllFiles}
                  allProcessedFiles={allProcessedFiles}
                  setAllProcessedFiles={setAllProcessedFiles}
                />
              )}
            {!isVerifying && livefeedbackInvalidDoc && !passwordProtected && (
              // <WrongDocument allFiles={allFiles} setAllFiles={setAllFiles} allProcessedFiles={allProcessedFiles} setAllProcessedFiles={setAllProcessedFiles}/>
              <LiveFeedbackInvalidPopup allFiles={allFiles} setAllFiles={setAllFiles} allProcessedFiles={allProcessedFiles} setAllProcessedFiles={setAllProcessedFiles} />
            )}

            {!isVerifying && imageUnprocessable == true && !passwordProtected && (
              <ImageToPdfFailed />
            )}

            {!isVerifying && somethingWentWrong && !passwordProtected && (
              <SomethingWentWrong
                allFiles={allFiles}
                setAllFiles={setAllFiles}
                allProcessedFiles={allProcessedFiles}
                setAllProcessedFiles={setAllProcessedFiles}
              />
            )}
            {!isVerifying && (isUnsupportedMedia || fileAlreadyExists || imageNotAllowed) && !passwordProtected && (
              <UnsupportedMedia
                fileAlreadyExists={fileAlreadyExists}
                allFiles={allFiles}
                setAllFiles={setAllFiles}
                allProcessedFiles={allProcessedFiles}
                setAllProcessedFiles={setAllProcessedFiles}
              />
            )}
            {!isVerifying && passwordProtected && (
              <PasswordProtected
                allFiles={allFiles}
                setAllFiles={setAllFiles}
                allProcessedFiles={allProcessedFiles}
                setAllProcessedFiles={setAllProcessedFiles}
              />
            )}
            {!isVerifying && corruptFile && !passwordProtected && (
              <CorruptFile allFiles={allFiles} setAllFiles={setAllFiles} allProcessedFiles={allProcessedFiles} setAllProcessedFiles={setAllProcessedFiles} />
            )}
            {!isVerifying && limitExceed && !passwordProtected && (
              <LimitExceed allFiles={allFiles} setAllFiles={setAllFiles} allProcessedFiles={allProcessedFiles} setAllProcessedFiles={setAllProcessedFiles} />
            )}
            {!isVerifying && urlNotFound?.data?.message === "URL not found" && !passwordProtected && (
              <UrlNotFound allFiles={allFiles} setAllFiles={setAllFiles} allProcessedFiles={allProcessedFiles} setAllProcessedFiles={setAllProcessedFiles} />
            )}
            {!isVerifying &&
              !processingLivefeedback &&
              !processingOneShotUpload &&
              !somethingWentWrong &&
              !passwordProtected &&
              (documentIsVerified || documentIsNotOriginal) &&
              oneShotUploadSuccessResponse?.error === false && (

                <ThankYouModal />
              )}
          </>
        </div>
      </div>
    </div>
  );
}
